import api from ".";

export default async function getTowers(condominiumId: number | string) {
  const response = await api.get(`/condominium/getTowers/${condominiumId}`);

  return response.data;
}
